import { Button, Modal } from 'reactstrap'
import styles from './waitBeforeYouGo.module.css'
import WaitBeforeYouGoIcon from 'assets/WaitBeforeYouGoIcon'
import HandHorn from 'assets/HandHorn'
import CloseIcon from 'assets/CloseIcon'

export default function WaitBeforeYouGo({ isOpen = false, onClose, onClick }) {
    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            centered
            style={{width:'100%', marginInline:'auto'}}
            className={styles.modalContainer}
        >
            <div className={`p-3 d-flex flex-row gap-4 align-items-center ${styles.responsiveWidth}`}>
                <div className={`flex-column border border-0 rounded ${styles.waitBeforeYouGoIconContainer}`}>
                    <WaitBeforeYouGoIcon />
                    <div className='text-center bg-white mx-4 px-4 rounded mb-3'>
                            Your next great deal is just a <span style={{ color: '#05945B' }}>step</span> away!
                    </div>
                </div>
                <div className='flex-column' style={{width:'100%'}}>
                    <p className={styles.title}>Wait! Before You Go... 🚪</p>
                    <p className={styles.subtitle}>We'd love to keep you around!</p>

                    <div className={styles.contentContainer}>
                        <div className="d-flex flex-row justify-content-between">
                            <div>
                                <p className={styles.contentTitle}>
                                    Why not take another look?
                                </p>
                                <p className={styles.contentSubtitle}>
                                    Here are a few things you might miss:
                                </p>
                            </div>
                            <div className={styles.HandHornMwebContainer}>
                                <HandHorn className={styles.HandHornMweb} />
                            </div>
                        </div>
                        <p className={styles.content}>
                            Freebies like E-books, Audios and Videos!
                        </p>
                    </div>
                    <Button
                        className={`w-100 mt-5 bg-transparent border-blue text-blue ${styles.button} `}
                        onClick={onClick}
                    >
                        Stay and Continue
                    </Button>
                </div>
            </div>
            <Button  className={styles.closeButton} style={{backgroundColor: '#F3F3F3', border: 'none'}}
            onClick={onClose}>
                <CloseIcon/>
            </Button>
        </Modal>
    )
}
